"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FeedItemMedia = void 0;
var FeedItemMedia = function () {
  function FeedItemMedia() {}
  FeedItemMedia.getAttributeTypeMap = function () {
    return FeedItemMedia.attributeTypeMap;
  };
  FeedItemMedia.discriminator = undefined;
  FeedItemMedia.attributeTypeMap = [{
    "name": "url",
    "baseName": "url",
    "type": "string"
  }, {
    "name": "poster",
    "baseName": "poster",
    "type": "string"
  }, {
    "name": "kind",
    "baseName": "kind",
    "type": "FeedItemMedia.KindEnum"
  }];
  return FeedItemMedia;
}();
exports.FeedItemMedia = FeedItemMedia;
(function (FeedItemMedia) {
  var KindEnum;
  (function (KindEnum) {
    KindEnum[KindEnum["Image"] = 'image'] = "Image";
    KindEnum[KindEnum["Video"] = 'video'] = "Video";
    KindEnum[KindEnum["Audio"] = 'audio'] = "Audio";
  })(KindEnum = FeedItemMedia.KindEnum || (FeedItemMedia.KindEnum = {}));
})(FeedItemMedia = exports.FeedItemMedia || (exports.FeedItemMedia = {}));
exports.FeedItemMedia = FeedItemMedia;